/* ============================================================
   THE FABRIC VAULT — Theme JavaScript
   Handles: header scroll, mobile drawer, cart drawer,
            search overlay, add-to-cart AJAX, cart updates
   ============================================================ */

(function () {
  'use strict';

  /* ── Header scroll effect ── */
  const header = document.getElementById('site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Mobile Drawer ── */
  const mobileToggle   = document.getElementById('mobile-menu-toggle');
  const mobileDrawer   = document.getElementById('mobile-drawer');
  const mobileClose    = document.getElementById('mobile-drawer-close');
  const mobileBackdrop = document.getElementById('mobile-drawer-backdrop');

  function openMobileDrawer() {
    mobileDrawer && mobileDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileDrawer() {
    mobileDrawer && mobileDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  mobileToggle  && mobileToggle.addEventListener('click', openMobileDrawer);
  mobileClose   && mobileClose.addEventListener('click', closeMobileDrawer);
  mobileBackdrop && mobileBackdrop.addEventListener('click', closeMobileDrawer);

  /* ── Cart Drawer ── */
  const cartToggle   = document.getElementById('cart-toggle');
  const cartDrawer   = document.getElementById('cart-drawer');
  const cartClose    = document.getElementById('cart-drawer-close');
  const cartBackdrop = document.getElementById('cart-drawer-backdrop');
  const cartCloseShop = document.getElementById('cart-close-shop');

  function openCartDrawer() {
    cartDrawer && cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    cartDrawer && cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartToggle   && cartToggle.addEventListener('click', openCartDrawer);
  cartClose    && cartClose.addEventListener('click', closeCartDrawer);
  cartBackdrop && cartBackdrop.addEventListener('click', closeCartDrawer);
  cartCloseShop && cartCloseShop.addEventListener('click', closeCartDrawer);

  /* ── Search Overlay ── */
  const searchToggle  = document.getElementById('search-toggle');
  const searchOverlay = document.getElementById('search-overlay');
  const searchClose   = document.getElementById('search-close');
  const searchInput   = document.getElementById('search-input');

  function openSearch() {
    searchOverlay && searchOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput && searchInput.focus(), 100);
  }
  function closeSearch() {
    searchOverlay && searchOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  searchToggle && searchToggle.addEventListener('click', openSearch);
  searchClose  && searchClose.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeSearch();
      closeMobileDrawer();
      closeCartDrawer();
    }
  });

  /* ── Add to Cart (AJAX) ── */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const btn = document.getElementById('add-to-cart');
      if (!btn) return;

      const originalText = btn.innerHTML;
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation:spin 0.8s linear infinite;"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg> Adding...';
      btn.disabled = true;

      const formData = new FormData(productForm);
      const variantId = formData.get('id');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (res.ok) {
          await updateCartCount();
          btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Added!';
          setTimeout(() => {
            btn.innerHTML = originalText;
            btn.disabled = false;
            openCartDrawer();
          }, 1200);
        } else {
          throw new Error('Add to cart failed');
        }
      } catch (err) {
        btn.innerHTML = originalText;
        btn.disabled = false;
        console.error('Add to cart error:', err);
      }
    });
  }

  /* ── Update Cart Count ── */
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const countEl = document.getElementById('cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    } catch (e) {
      console.error('Cart count update failed:', e);
    }
  }

  /* ── Intersection Observer for fade-in animations ── */
  if ('IntersectionObserver' in window) {
    const animateEls = document.querySelectorAll('.why-card, .review-card, .product-card, .collection-card');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    animateEls.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

  /* ── Spin keyframe for loading ── */
  const style = document.createElement('style');
  style.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(style);

  function changeToVideo(mediaId, mediaType, videoSrc, btn) {
  document.getElementById('main-product-image').style.display = 'none';
  const videoWrap = document.getElementById('main-product-video');
  videoWrap.style.display = 'block';
  videoWrap.innerHTML = `<video src="${videoSrc}" controls autoplay style="width:100%; height:auto; display:block;"></video>`;
  document.querySelectorAll('.product-gallery__thumb').forEach(b => b.style.borderColor = 'transparent');
  btn.style.borderColor = '#c59d5f';
}

function changeImage(src, btn) {
  document.getElementById('main-product-video').style.display = 'none';
  const img = document.getElementById('main-product-image');
  img.style.display = 'block';
  img.src = src;
  document.querySelectorAll('.product-gallery__thumb').forEach(b => b.style.borderColor = 'transparent');
  btn.style.borderColor = '#c59d5f';
}


})();
